var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiableCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54492 0.619629C3.68497 0.619629 0.544922 3.75967 0.544922 7.61963C0.544922 11.4796 3.68497 14.6196 7.54492 14.6196C11.4049 14.6196 14.5449 11.4796 14.5449 7.61963C14.5449 3.75967 11.4049 0.619629 7.54492 0.619629Z",
    stroke: "#636363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0926 6.13629L7.30089 9.92789C7.18713 10.0416 7.03781 10.0989 6.88849 10.0989C6.73917 10.0989 6.58984 10.0416 6.47609 9.92789L4.58029 8.03209C4.35214 7.80405 4.35214 7.43533 4.58029 7.20729C4.80833 6.97914 5.17694 6.97914 5.40509 7.20729L6.88849 8.69069L10.2678 5.31149C10.4958 5.08334 10.8644 5.08334 11.0926 5.31149C11.3206 5.53954 11.3206 5.90814 11.0926 6.13629Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiableCheck);
export default __webpack_public_path__ + "static/media/diable-check.dc66b4e621e2e2603dc5bc6620fb634b.svg";
export { ForwardRef as ReactComponent };